var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 72.1136,
    y2: -1.5,
    transform: "matrix(0.694518 0.719475 -0.694518 0.719475 1 3)",
    stroke: "#D6BC78",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 72.1136,
    y2: -1.5,
    transform: "matrix(0.694518 -0.719475 0.694518 0.719475 2.91577 55)",
    stroke: "#D6BC78",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconHover);
export default __webpack_public_path__ + "static/media/close-icon-hover.800f5c0da1893e6563e675a61a8ba559.svg";
export { ForwardRef as ReactComponent };